export default {
    supportedLngs: ["en", "fr"],
    fallbackLng: "en",
    defaultNS: "common",
};